const projects = [
  {
    id: 1,
    title: "Patient-Specific Seizure Detection",
    category: "AI / Deep Learning",
    description:
      "Built a patient-specific seizure detection model using deep learning optimized for low computational complexity and real-time EEG analysis. Achieved 98.7% accuracy on the CHB-MIT dataset using a Transformer-based architecture with optimized electrode selection.",
    used: ["Python", "TensorFlow/Keras", "Streamlit", "NumPy", "Pandas"],
    link: "",
    repo: "https://github.com/Arunkumar-eng",
  },
  {
    id: 2,
    title: "Public Chatting Forum",
    category: "Networking / Web",
    description:
      "Real-time chat application using WebSocket communication for low-latency, bidirectional messaging on a LAN. Integrated No-IP dynamic DNS for stable access and supports concurrent sessions with efficient message broadcast.",
    used: ["Python", "Flask", "Socket.io", "HTML/CSS", "JavaScript"],
    link: "",
    repo: "https://github.com/Arunkumar-eng",
  },
  {
    id: 3,
    title: "Notes Manager",
    category: "Web Application",
    description:
      "Web application that allows users to create, edit, and manage their to-do lists with a clean, intuitive interface.",
    used: ["React", "Bootstrap 5"],
    link: "https://arunkumar-eng.github.io/Notes-Manager/",
    repo: "https://github.com/Arunkumar-eng/Notes-Manager/",
  },
  {
    id: 4,
    title: "News App",
    category: "Web Application",
    description:
      "Web application that uses Google's News API to fetch and display the current top headlines with category-based filtering.",
    used: ["Django", "Google News API", "Python"],
    link: "https://news-app-arunkumar49r.vercel.app/",
    repo: "https://github.com/Arunkumar-eng/NewsApp",
  },
];

export default projects;